var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRsu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13.758333 6.8791665",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1401"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.166295
    },
    d: "M 13.57443,5.1939195 13.561136,0.28306109 6.9146261,2.6507748 0.21694498,0.27745887 0.25242948,5.1773314 6.9154805,2.7932225 Z",
    id: "path792"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1777bd",
      stroke: "none",
      strokeWidth: 0.0740405,
      strokeDasharray: "none"
    },
    d: "M 0.27611402,0.33533273 6.9176784,2.7194993 0.36573035,5.0664132 Z",
    id: "OperationStatus"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4da2c",
      stroke: "none",
      strokeWidth: 0.0731684,
      strokeDasharray: "none"
    },
    d: "M 13.442207,0.39144273 13.452102,5.1039225 6.9019879,2.7136858 Z",
    id: "CommunicationStatus"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "#000000",
      strokeWidth: 0.1,
      strokeDasharray: "none"
    },
    d: "m 6.9019464,2.7824086 -0.00983,3.873742",
    id: "path1395"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsu);
export default __webpack_public_path__ + "static/media/RSU.313c9e5834ce465d27859124a8b82386.svg";
export { ForwardRef as ReactComponent };